<template>
  <div class="bg-white p-2" v-loading="isLoading">
    <h5 class="page-title">Masterlist ULD History</h5>
    <el-table :data="masterlist.data">
      <el-table-column
        min-width="100px"
        label="ID CODE"
        prop="uld_id_code"
      ></el-table-column>
      <el-table-column
        min-width="130px"
        label="JOB ORDER NO"
        prop="job_order_number"
      >
        <template slot-scope="scope">
          <a
            target="_blank"
            :href="`/repair/repair-uld/info/${scope.row.id}`"
            >{{ scope.row.job_order_number }}</a
          >
        </template>
      </el-table-column>
      <el-table-column
        min-width="140px"
        label="DATE RECEIVED"
        prop="date_received"
      >
        <template slot-scope="scope">
          {{ scope.row.date_received | dateFormat("DD-MMM-YY") }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="100px"
        label="STATUS"
        prop="status"
      ></el-table-column>
      <el-table-column
        min-width="140px"
        label="DATE COMPLETED"
        prop="date_completed"
      >
        <template slot-scope="scope">
          {{ scope.row.date_completed | dateFormat("DD-MMM-YY") }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="140px"
        label="DATE DELIVERED"
        prop="date_delivered"
      >
        <template slot-scope="scope">
          {{ scope.row.uld_out.delivery_date | dateFormat("DD-MMM-YY") }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="140px"
        label="DEL. NOTE NO."
        prop="uld_out.delivery_num"
      >
      </el-table-column>
      <el-table-column min-width="100px" label="INVOICE NO." prop="invoice_no">
      </el-table-column>
      <el-table-column min-width="150px" label="REMARKS" prop="remarks">
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="!isLoading"
      class="pt-1 pb-1"
      background
      layout="prev, pager, next"
      :total="masterlist.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(masterlist.paging.cur_page)"
      @current-change="fetch"
    >
    </el-pagination>
  </div>
</template>

<script>
import Masterlist from "@/models/Masterlist";
export default {
  name: "MasterlistULD",
  data: () => ({
    isLoading: false,
    masterlist: { paging: {} },
    pager: {
      limit: 5,
      page: 1
    }
  }),
  methods: {
    fetch(page) {
      let params = {
        masterlist_id: this.$route.params.id,
        page: page ? page : 1,
        limit: this.pager.limit
      };
      this.isLoading = true;
      Masterlist.getULDList(params).then(data => {
        this.masterlist = data;
        this.isLoading = false;
      });
    }
  },
  mounted() {
    this.fetch(1);
  }
};
</script>

<style lang="scss" scoped></style>
